import { environment } from 'environments/environment';

/* eslint-disable @typescript-eslint/naming-convention */
export class AppConstants {
  // session constants
  public static SESSION_IDLE_TIME = 30 * 60; // total session time is 30 mins
  public static SESSION_TIMEOUT = 0.5 * 60; // fire session expiry alert before 30 seconds
  public static SESSION_PING_TIME = 1 * 60; // in 60 seconds

  // Date Format
  public static FILENAME_DATE_FORMAT = 'DDMMYY_HHmmss';
  public static FORMONTH_DATE_FORMAT = 'MMMM YYYY';

  public static JSReports = {
    // serverUrl: 'http://localhost:5488/report',
    serverUrl: environment.reportServer,
    access: {
      ue: 'reportgenerator-admin',
      pd: 'R3portG3n3rat0r',
    },
    shortIds: {
      incomeExpense: {
        condensed: 'aWxqrshaNF',
        combined: 'YC-L_p-BAL',
        detailed: 'HHj7nzzPj4',
      },
      ledgerReport: {
        condensed: 'aJg-p_rNfk',
        combined: 'n83urqTzVa',
        detailed: 'lkVAI-r6ZU',
      },
      specialDates: {
        default: 'mrV6nN05cz',
      },
      invoice: {
        subscription: 'FTJrBjeH8x',
        transaction: 'dpexPoeEH7',
      },
      reportList: {
        lists: 'CypdBdddjN',
      },
      member: {
        memberList: 'M83APm2kRm',
        individualMember: 'Iv48yzHaOJ',
        familyReport: 'odq_Z2qyUo',
        memberReportList: 'OEH0tTO',
      },
      groups: {
        groupList: 'cKX7o2rNxh',
      },
      reports: {
        certificates: 'PGaHgul1Zc',
      },
      pledge: {
        pledgeItem: 'urJeEcCX0x',
      },
      userActivity: {
        userActivityList: 'E0x_YMmdzh',
      },
      wedding: {
        beforeBanns: '0YW2hCuh2Y',
        afterBanns: 'QCWlAA8AJx',
        weddingParticular: 'o1ZcafvNC',
      },
      sermon: {
        sermonDetail: '98n7lSlF2u',
      },
      missionTrip: {
        missionTripDetail: 'L9Z-L5oQ74',
      },
    },
  };
}
